import React, { useEffect, createElement } from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { SalesLetter } from './components/SalesLetter';
import { WhatYouGet } from './components/WhatYouGet';
import { BonusSection } from './components/BonusSection';
import { PricingOffer } from './components/PricingOffer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SocialProof } from './components/SocialProof';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
    window.fbq('init', '1935155573773151');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream-100 font-sans text-espresso-900 pt-10" data-id="element-0">
      <StickyAlertBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SalesLetter data-id="element-4" />
        <WhatYouGet data-id="element-5" />
        <BonusSection data-id="element-6" />
        <PricingOffer data-id="element-7" />
        <GuaranteeSection data-id="element-8" />
        <SocialProof data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}